import { Close } from '@myua/icons/dist/linear24';
import { message } from '@myua/kit';

const WARNING_KEY = 'ai-search-warning';

export function showNonLatinWarning() {
  void message.warning({
    content: (
      <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
        For best AI search results, use English
        <Close
          onClick={() => message.destroy(WARNING_KEY)}
          style={{ marginLeft: 8, cursor: 'pointer', fontSize: 24 }}
        />
      </span>
    ),
    duration: 10,
    key: WARNING_KEY,
  });
}
